import type { Material, Object3D, Texture } from "three";
import { Mesh } from "three";

const disposeMaterial = (material: Material): void => {
  // Les textures ne sont pas listées par le matériau : on balaie ses champs.
  for (const value of Object.values(material)) {
    if (value && typeof value === "object" && "isTexture" in value) {
      (value as Texture).dispose();
    }
  }
  material.dispose();
};

/**
 * Libère géométries, matériaux et textures d'un sous-arbre.
 * Ne détache pas le nœud de son parent : c'est au propriétaire de le faire.
 */
export const disposeObject3D = (root: Object3D): void => {
  root.traverse((child) => {
    if (!(child instanceof Mesh)) return;
    child.geometry.dispose();
    const material: Material | Material[] = child.material;
    if (Array.isArray(material)) material.forEach(disposeMaterial);
    else disposeMaterial(material);
  });
};
